var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpheronLogoCircle = function SvgSpheronLogoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#spheron-logo-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.58 19.571v12.063a1.82 1.82 0 0 1-.878 1.556l-.075.044-2.823 1.621-16.412 9.443-1.993 1.146s-.004 0-.005.005a.5.5 0 0 0-.095.053.91.91 0 0 0 .075 1.555l2.257 1.298 7.681 4.419q.003 0 .006.002l.136.08a.904.904 0 0 1 0 1.487l-.133.075L37.28 62.5l-.079.045a1.8 1.8 0 0 1-.867.22c-.273 0-.543-.061-.79-.178l-.078-.042-.12-.07L27.22 57.8l-2.693-1.55a1.793 1.793 0 0 1-.707-.688 1.77 1.77 0 0 1-.247-.908v-12.59a1.81 1.81 0 0 1 .878-1.555 1 1 0 0 1 .105-.06l2.663-1.534 8.987-5.17 10.833-6.226 15.121-8.695a1 1 0 0 1 .076-.044.91.91 0 0 1 1.345.795z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.213 45.346v12.589a1.81 1.81 0 0 1-.877 1.552q-.04.025-.076.045l-2.693 1.55-3.407 1.96-5.58 3.209-10.832 6.231-15.118 8.695a.896.896 0 0 1-.511.155.91.91 0 0 1-.913-.909V68.36a1.81 1.81 0 0 1 .99-1.616l2.788-1.606 16.411-9.44 1.967-1.13h.004l.126-.072.014-.009a.908.908 0 0 0-.105-1.552l-2.245-1.293-7.683-4.42h-.005l-.147-.087h-.003a.902.902 0 0 1-.003-1.47h.005l.153-.089.023-.013 13.995-8.052.11-.063a1.83 1.83 0 0 1 1.69-.004l.12.07 8.155 4.69 2.693 1.55a1.794 1.794 0 0 1 .707.689c.162.274.248.588.246.908z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spheron-logo-circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.573 18.667h52.64v62.667h-52.64z"
  })))));
};
export default SvgSpheronLogoCircle;